import {
  Component,
  OnInit
} from '@angular/core';

import {AppState} from '../app.service';
import {Title, Meta} from '@angular/platform-browser';
import {CompanyService} from "../services/company-service/company-service";
import {CompanyVM} from "../models/CompanyVM.model";
import {MarkerVMModel} from "../models/MarkerModel";
import {WorkSpaceVMModel} from "../models/WorkSpaceVMModel";
import {ImageVM} from "../models/ImageVM.model";
import {ScheduleInfoDTO, WEEKDAYS, WorkDayVM} from "../models/ServiceItemDetailVM";
import {PermissionService} from "../services/permission/permission.service";
import {DateUtilService} from "../services/date-service/DateUtilService";
import {ActivatedRoute, Router} from "@angular/router";
import {IAppConfig} from "../models/app-config.model";
import {AppConfig} from "../services/app.config";
import {CacheUtilService} from "../services/cache-util/CacheUtilService";


@Component({
  /**
   * The selector is what angular internally uses
   * for `document.querySelectorAll(selector)` in our index.html
   * where, in this case, selector is the string 'home'.
   */
  selector: 'home',  // <home></home>
  /**
   * We need to tell Angular's Dependency Injection which providers are in our app.
   */
  providers: [
   PermissionService,
    DateUtilService
  ],
  /**
   * Our list of styles in our component. We may add more to compose many styles together.
   */
  styles: [require('./home.component.css')],
  /**
   * Every Angular template is first compiled by the browser before Angular runs it's compiler.
   */
  template: require('./home.component.html')
})
export class HomeComponent implements OnInit {

  /**
   * Set our default values
   */
  public isCardViewMode = false;
  public isParent = false;
  public localState = {value: ''};
  public company: CompanyVM;
  public currentLocation: MarkerVMModel;
  companydetail: CompanyVM;
  public workSpaceList: WorkSpaceVMModel[] = [];
  public imageUrl: String;
  public coverImage: ImageVM;
  public companySocials: any[];
  workingTime: ScheduleInfoDTO;
  public workingDays: WorkDayVM[] = [];
  public companyLoaded = false;
  public canReserveByClient: boolean;
  public canReserveByWidget: boolean;
  public isSubscriptionStatusValid: boolean;
  public inIframe=false;
  public themeType='DEFAULT_THEME';
  companyKeyUrl = null;
  public setting: IAppConfig = AppConfig.settings;
  showCustomTheme = false;
  themeHeaderType = 'MODERN_HEADER';
  openHoursToReserve : any;
  clientBookingComponentType = 'DEFAULT';

  /**
   * TypeScript public modifiers
   */
  constructor(public appState: AppState, private pageTitle: Title, private companyService: CompanyService
              , private permissionService: PermissionService
              , private activatedRoute: ActivatedRoute
              , private router:Router
              , private cacheUtilService : CacheUtilService
  ) {
  this.isSubscriptionStatusValid = true;
  this.openHoursToReserve={};
  this.openHoursToReserve.canClientReserveNow = 'true';
  }

  public ngOnInit() {


    this.activatedRoute.params.subscribe(params => {

      let clearCache = params['clearCache'] ;
      if(clearCache)
        this.cacheUtilService.clearCache();

      // console.log(params['reserveId']);
      this.companyKeyUrl = params['companyKeyUrl'] ;

    });

    let parent = this;
    this.inIframe=this.companyService.inIframe();
    this.companyService.getCompanyInfo(this.companyKeyUrl).subscribe((c) => {
      this.companydetail = c;
      this.getCompanyImageList(c);
      this.makeWorkSpaceList();


      this.makeSocialNetworkList();
      parent.checkGate(parent.companydetail);
      this.permissionService.isSubscriptionValid(this.companydetail.keyUrl).subscribe(res => {
        this.isSubscriptionStatusValid = res;
      });

      this.companyService.getCompanyOpenHoursToReserve(this.companydetail.id).subscribe(res => {
        this.openHoursToReserve = res;
      });

      if(this.setting.ui.custom_theme_key_url && c.keyUrl == this.setting.ui.custom_theme_key_url)
      {
        this.showCustomTheme = true;
      }





    })


    this.setPageTitle();
  }
  checkGate(company){

    const parent = this;
    parent.canReserveByClient = this.companyService.getCompanyCustomSetting(company, 'canReserveByClient');
    parent.canReserveByWidget = this.companyService.getCompanyCustomSetting(company, 'canReserveByWidget');
    parent.clientBookingComponentType = this.companyService.getCompanyCustomSetting(company, 'clientBookingWidgetType');

  }
  public setServiceViewMode(c: CompanyVM) {
    this.isCardViewMode = false;
    if (c.activityType != 'OTHER') {
      this.isCardViewMode = true;
    }
  }

  public checkIfIsParentCompany(company: CompanyVM) {
    this.isParent = false;
    if (company.customSetting) {
      let isParent = this.companyService.getCompanyCustomSetting(company, 'isParent');

      if (isParent && (isParent == 'true' || isParent == true)) {
        this.isParent = true;
      }


    }

  }

  public setPageTitle() {
    let title = 'صفحه اصلی';
    let parent = this;
    this.companyService.getCompanyInfo(this.companyKeyUrl).subscribe((c) => {
      parent.company = c;
      this.pageTitle.setTitle(c.title + " - " + title);
      parent.setServiceViewMode(c);
      parent.checkIfIsParentCompany(c);
      parent.companyLoaded = true;
      parent.checkTheme(c);


    })
  }

  public submitState(value: string) {
    this.appState.set('value', value);
    this.localState.value = '';
  }

  initCuurentLocation() {
    this.currentLocation = new MarkerVMModel(35.736365, 51.375714);
  }

  makeWorkSpaceList() {
    let parent = this;
    let com = this.companydetail;
    if (com.location && com.location.mapY && com.location.mapX) {

      let o1 = new MarkerVMModel(+com.location.mapX, +com.location.mapY);
      this.currentLocation = new MarkerVMModel(+com.location.mapX, +com.location.mapY);
      let workSpace = new WorkSpaceVMModel(o1);
      workSpace.title = com.title;
      workSpace.detail = com.location.address
      parent.companyService.getCompanyLogoImage(com).subscribe(((logo) => {
        workSpace.image = logo;
      }))

      parent.workSpaceList.push(workSpace);
    }
    else {
      this.initCuurentLocation();
    }
  }

  getCompanyImageList(com: CompanyVM) {
    let parent = this;
    parent.imageUrl = parent.companyService.makeImageUrl('company', parent.coverImage, parent.companydetail.activityType, false);
    if (com && com.setting && com.setting.themeSettingInfo) {
      let albumid = com.setting.themeSettingInfo.albumInfoId;

      this.companyService.getAlbumImageList(albumid).subscribe((imageList) => {
        if (imageList && imageList.length > 0)
          parent.coverImage = imageList[0];
        parent.imageUrl = parent.companyService.makeImageUrl('company', parent.coverImage, parent.companydetail.activityType, false);
      }, (res) => {
      })
    }
  }

  makeSocialNetworkList() {
    if (this.companydetail)
      this.companyService.getCompanySocialNetwork(this.companydetail.id).subscribe((sns) => {
        this.companySocials = sns;

        // (MA)I put this part here because it needs to be checked after the service completely loaded,
        // so to have an unnoticed delay I put it here after above service loaded
        if (this.companydetail)
          this.fillCompanyWorkingTime();
      })
  }

  private fillCompanyWorkingTime() {
    if (this.companydetail) {
      this.companyService.getCompanyWorkingTime(this.companydetail.id).subscribe(wt => {
        this.workingTime = wt;
        //this.makeWorkindDays(this.workingTime);
        this.makeWorkindDays(wt);
        // this.inited=true;

      });

    }
  }

  private makeWorkindDays(workingTime: ScheduleInfoDTO): void {
    let parent = this;
    if (workingTime && workingTime.weeklyScheduleInfo && workingTime.weeklyScheduleInfo.weekdays) {
      var weekdays = Object.keys(WEEKDAYS);
      var WEEKDAYS_ENUM = WEEKDAYS;
      weekdays = weekdays.slice(weekdays.length / 2, weekdays.length);
      weekdays.forEach((day) => {
        let foundIndex = workingTime.weeklyScheduleInfo.weekdays.findIndex((item) => {
          if (item.weekday.toString() == day) return true;
        })

        if (foundIndex > -1) {
          let cworkday = workingTime.weeklyScheduleInfo.weekdays[foundIndex];
          let workday: WorkDayVM = new WorkDayVM();
          workday.weekday = day.toString();
          if (cworkday.timePeriod)
            workday.timePeriod = cworkday.timePeriod;
          else
            workday.timePeriod = workingTime.weeklyScheduleInfo.timePeriod;
          parent.workingDays.push(workday)
        }

      })

    }
  }

  checkTheme(company){

    const parent = this;
    if (company && company.setting && company.setting.themeSettingInfo
      && company.setting.themeSettingInfo.themeType && company.setting.themeSettingInfo.themeType == 'MODERN_THEME') {
        parent.themeType = 'MODERN_THEME';
      //set header theme
      if(company.setting.themeSettingInfo.themeHeaderType)
        parent.themeHeaderType = company.setting.themeSettingInfo.themeHeaderType;
      else
        parent.themeHeaderType = 'MODERN_HEADER';
    }
    else
    {
      parent.themeType = 'DEFAULT_THEME';
    }
  }


  goToCustomCompanyLink(keyUrl,isLevel1)
  {
    // if(company.keyUrl)
    // {
    //   let url = 'https://'+company.keyUrl;
    //   if(this.setting.ui.app_name == 'planovin')
    //     url = url+'.' + this.setting.ui.app_name + '.com'
    //   if(this.setting.ui.app_name == 'reserweb')
    //     url = url + this.setting.ui.app_name + '.ir'
    //
    //   window.location.href = url;
    // }

    if(isLevel1)
      this.router.navigate(['/companyProfileParentLevel1', keyUrl])
    else
      this.router.navigate(['/companyProfileParent', keyUrl])

  }

  scrollToServiceSection(el: HTMLElement)
  {
    el.scrollIntoView();
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/home/home.component.ts